import * as Yup from 'yup';

export default Yup.object().shape({
  comment: Yup.string().required('SCHEMA_ERRORS.REQUIRED_FIELD')
});
